import React, { Component } from "react";
import {
  InputGroup,
  InputGroupAddon,
  Input,
  Row,
  Col,
  Button,
  Table
} from "reactstrap";
import { reduxForm } from 'redux-form'
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Collapsible from 'react-collapsible';
import BlockUi from 'react-block-ui';
import Pagination from "react-js-pagination";
import { ROLE_LIST_SUCCESS } from './constants'
import * as roleAction from './actions'
import { storedb } from '../../views/client/storedb'
import { BtnPermissions } from '../../lib/BtnPermissions';
import { ButtonExt } from "../controls/ButtonExt"

class Role extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    roleListRequest: PropTypes.func,
    roleUpdateRequest: PropTypes.func,
    role: PropTypes.shape({
      list: PropTypes.array,
      item: PropTypes.object,
      type: PropTypes.string,
      listRequesting: PropTypes.bool,
      requesting: PropTypes.bool,
      successful: PropTypes.bool,
      messages: PropTypes.array,
      errors: PropTypes.array,
    }),
  }
  constructor(props) {
    super(props);
    var dbContext = storedb();
    this.state = {
      stores_id: dbContext.getStoreId(),
      item: {},
      list: [],
      TrangThaiId: '',
      keyword: '',
      per_page: 20,
      page: 1,
      total_record: 0
    };
  }
  handlePageChange = (pageNumber) => {
    let page = parseInt(pageNumber || 1)
    return this.setState({ page }, this.fetchList);
  }
  handleSearchChange = (name, e, value) => {
    switch (name) {
      case "keyword":
        this.setState({ keyword: e.target.value });
        break;
      default:
        break;
    }
  }
  handleSelectChange = (name, selectedOption) => {
    switch (name) {
      case "TrangThai":
        this.setState({ TrangThaiId: selectedOption.target.value })
        break;
      default:
        break;
    }
  }
  fetchList = () => {
    const { roleListRequest } = this.props

    var requestData = {
      stores_id: this.state.stores_id,
      keyword: this.state.keyword,
      status: this.state.TrangThaiId,
      page: this.state.page,
      per_page: this.state.per_page
    };
    return roleListRequest(requestData);
  }
  search = () => {
    if (this.props.role.listRequesting) {
      return false;
    }
    return this.fetchList()
  }
  keyPress = (e) => {
    if(e.keyCode == 13){
       this.search()
    }
  }
  refresh = () => {
    this.setState({
      stores_id: this.state.stores_id,
      keyword: '',
      TrangThaiId: '',
      page: this.state.page,
      per_page: this.state.per_page
    }, () => {
      if (this.props.role.listRequesting) {
        return false;
      }
      return this.fetchList()
    })
  }
  EditRoleItem = (item) =>
  {
    this.props.history.push('/role-edit?role=' + (item.RoleId || ""));
  }
  viewRoleItem = (e, RoleId) => {
    e.preventDefault()
    this.props.history.push('/role-edit?role=' + (RoleId || ""));
  }
  componentDidMount() {
    this.fetchList();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.role.type == ROLE_LIST_SUCCESS) {
      let { list, item } = nextProps.role;
      this.setState({
        page: item.page,
        per_page: item.per_page,
        total_record: item.total_record,
        list
      });
    }
  }

  render() {
    const { list } = this.state;
    const {
      handleSubmit,
      role: {
        listRequesting
      },
    } = this.props
    return (
      <div className="animated fadeIn">
        <BlockUi tag="div" blocking={listRequesting} >
          <div>
            <Collapsible trigger="Tìm kiếm..." open={true}>
              <Row>
                <Col sm="8" className="mb-2">
                  <InputGroup size="md">
                    <InputGroupAddon addonType="prepend" autoComplete="off" >Tên quyền</InputGroupAddon>
                    <Input name="keyword" value={this.state.keyword} 
                    onChange={this.handleSearchChange.bind(this, "keyword")} 
                    onKeyDown={e => this.keyPress(e)}/>
                  </InputGroup>
                </Col>
                <Col sm="4" className="mb-2">
                  <InputGroup size="md">
                    <InputGroupAddon addonType="prepend">Trạng thái</InputGroupAddon>
                    <select className="form-control" value={this.state.TrangThaiId} onChange={this.handleSelectChange.bind(this, "TrangThai")}>
                      <option value="">Trạng thái</option>
                      <option value={1}>Hoạt động</option>
                      <option value={0}>Ngừng hoạt động</option>
                    </select>
                  </InputGroup>
                </Col>
              </Row>
            </Collapsible>
          </div>
          <div className="mt-2 bg-white">
            <div className="w-100 mb-2">
              <Button size="md" color="success" className="pull-left mr-1" onClick={handleSubmit(this.search)}><i className="fa fa-search"></i> Tìm kiếm</Button>
              <ButtonExt btnClass="mr-1"
                color="primary"
                iconClass="fa-plus"
                displayText="Thêm mới"
                btnClick={() => this.EditRoleItem({})}
                permission={BtnPermissions.Role.ADD_OR_UPDATE} />
            </div>
            <div className="w-100">
       
              <Table hover responsive className="table-outline mb-0 d-sm-table table-sm">
                <thead className="thead-default">
                  <tr>
                    <th scope="col" width="50" className="text-center">#</th>
                    <th scope="col" className="text-left">Nhóm người dùng</th>
                    <th scope="col" width="80" className="text-center">Trạng thái</th>
                  </tr>
                </thead>
                <tbody>
                  {list && !!list.length && (
                    list.map((res, idx) => (
                      <tr key={idx + 1}>
                        <td className="text-center">{idx + 1}</td>
                        <td className="text-left"><a href='#' onClick={(e) => this.viewRoleItem(e, res.RoleId)}> {res.Name}</a> </td>
                        <td className="text-center"> {res.Status == 1 ? <span className="text-success"><i className="fa fa-check"></i></span> : <span className="text-danger"><i className="fa fa-close"></i></span>}</td>
                      </tr>
                    ))
                  )}
                </tbody>
                <tfoot>
                  <tr>
                    <td colSpan="3">
                      <span className="text-success mr-2"><i className="fa fa-check"></i> = Đang hoạt động</span>
                      <span className="text-danger"><i className="fa fa-close"></i> = Dừng hoạt động</span>
                    </td>
                  </tr>
                </tfoot>
              </Table>
           
              {this.state.total_record > this.state.per_page && (
                <Pagination
                  activePage={this.state.page}
                  itemsCountPerPage={this.state.per_page}
                  totalItemsCount={this.state.total_record}
                  pageRangeDisplayed={5}
                  onChange={this.handlePageChange}
                />
              )}
            </div>
            <div className="clearfix"></div>
          </div>
        </BlockUi>
      </div>
    )
  }
}
const mapStateToProps = state => ({
  role: state.role,
  client: state.client,
})
const connected = connect(mapStateToProps, {
  roleListRequest: roleAction.roleListRequest,
  roleUpdateRequest: roleAction.roleUpdateRequest,
})(Role)
const formed = reduxForm({
  form: 'role',
})(connected)
export default formed;



// WEBPACK FOOTER //
// ./src/views/Role/Role.js